// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentEventData$OrcaPaymentPage from "../../shared-code/sdk-utils/events/PaymentEventData.bs.js";
import * as SubscriptionEventTypes$OrcaPaymentPage from "../Types/SubscriptionEventTypes.bs.js";

function useSubscriptionEventEmitter() {
  var options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var subscribedEvents = options.subscriptionEvents;
  var emitCardInfo = function (cardInfo) {
    if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("PaymentMethodInfoCard", Core__Option.getOr(subscribedEvents, []))) {
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createCardInfoPayload(cardInfo));
    }
    
  };
  var emitPaymentMethodStatus = function (paymentMethod, paymentMethodType, isSavedPaymentMethod, isOneClickWalletOpt) {
    var isOneClickWallet = isOneClickWalletOpt !== undefined ? isOneClickWalletOpt : false;
    if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("PaymentMethodStatus", Core__Option.getOr(subscribedEvents, []))) {
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createPaymentMethodStatusPayload(paymentMethod, paymentMethodType, isSavedPaymentMethod, isOneClickWallet));
    }
    
  };
  var emitBillingAddress = function (country, state, postalCode) {
    if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("PaymentMethodInfoBillingAddress", Core__Option.getOr(subscribedEvents, []))) {
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createBillingAddressPayload(country, state, postalCode));
    }
    
  };
  var emitCvcStatus = function (iframeId, isCvcEmpty, isCvcComplete) {
    if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("CvcStatus", Core__Option.getOr(subscribedEvents, []))) {
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createCvcStatusPayload(iframeId, isCvcEmpty, isCvcComplete));
    }
    
  };
  var emitSurcharge = function (surchargeDetails) {
    if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("Surcharge", Core__Option.getOr(subscribedEvents, [])) && Core__Option.isSome(surchargeDetails)) {
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createSurchargePayload(surchargeDetails));
    }
    
  };
  return {
          emitCardInfo: emitCardInfo,
          emitPaymentMethodStatus: emitPaymentMethodStatus,
          emitBillingAddress: emitBillingAddress,
          emitCvcStatus: emitCvcStatus,
          emitSurcharge: emitSurcharge
        };
}

function emitReady(iframeId, elementType) {
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "ready",
          true
        ],
        [
          "elementType",
          elementType
        ],
        [
          "iframeId",
          iframeId
        ]
      ]);
}

function useEmitFormStatus(empty, complete, isOneClickWalletOpt) {
  var isOneClickWallet = isOneClickWalletOpt !== undefined ? isOneClickWalletOpt : false;
  var options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var subscribedEvents = options.subscriptionEvents;
  React.useEffect((function () {
          if (!isOneClickWallet) {
            var formStatusValue = PaymentEventData$OrcaPaymentPage.computeFormStatus(complete, empty);
            if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("FormStatus", Core__Option.getOr(subscribedEvents, []))) {
              Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createFormStatusPayload(formStatusValue));
            }
            
          }
          
        }), [
        empty,
        complete,
        isOneClickWallet,
        subscribedEvents
      ]);
}

function useEmitBillingAddress() {
  var country = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userCountry);
  var state = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userAddressState).value;
  var pinCode = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.userAddressPincode).value;
  var options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var subscribedEvents = options.subscriptionEvents;
  React.useEffect((function () {
          if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("PaymentMethodInfoBillingAddress", Core__Option.getOr(subscribedEvents, []))) {
            Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createBillingAddressPayload(country, state, pinCode));
          }
          
        }), [
        country,
        state,
        pinCode,
        subscribedEvents
      ]);
}

function getPaymentMethodAndType(paymentMethodName, paymentMethods, logger) {
  if (paymentMethodName.includes("_debit")) {
    return [
            "bank_debit",
            paymentMethodName
          ];
  }
  if (paymentMethodName.includes("_transfer")) {
    return [
            "bank_transfer",
            paymentMethodName
          ];
  }
  if (paymentMethodName === "card") {
    return [
            "card",
            "debit"
          ];
  }
  var found = paymentMethods.filter(function (pm) {
          return pm.payment_method_types.filter(function (t) {
                      return t.payment_method_type === paymentMethodName;
                    }).length > 0;
        })[0];
  if (found !== undefined) {
    return [
            found.payment_method,
            paymentMethodName
          ];
  } else {
    logger.setLogError("Payment method type not found", "PAYMENT_METHOD_TYPE_DETECTION_FAILED", undefined, undefined, undefined, undefined, undefined);
    return ;
  }
}

function useEmitPaymentMethodStatus(paymentMethodName, paymentMethods, isSavedPaymentMethod, isOneClickWallet) {
  var loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  var options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var subscribedEvents = options.subscriptionEvents;
  React.useEffect((function () {
          if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("PaymentMethodStatus", Core__Option.getOr(subscribedEvents, []))) {
            var match = getPaymentMethodAndType(paymentMethodName, paymentMethods, loggerState);
            if (match !== undefined) {
              Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createPaymentMethodStatusPayload(match[0], match[1], isSavedPaymentMethod, isOneClickWallet));
            }
            
          }
          
        }), [
        paymentMethodName,
        paymentMethods,
        isSavedPaymentMethod,
        isOneClickWallet,
        subscribedEvents
      ]);
}

function useEmitSurchargeInfo(surchargeDetails) {
  var options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var subscribedEvents = options.subscriptionEvents;
  React.useEffect((function () {
          if (PaymentEventData$OrcaPaymentPage.shouldEmitEvent("Surcharge", Core__Option.getOr(subscribedEvents, [])) && Core__Option.isSome(surchargeDetails)) {
            Utils$OrcaPaymentPage.messageParentWindow(undefined, SubscriptionEventTypes$OrcaPaymentPage.createSurchargePayload(surchargeDetails));
          }
          
        }), [
        surchargeDetails,
        subscribedEvents
      ]);
}

export {
  useSubscriptionEventEmitter ,
  emitReady ,
  useEmitFormStatus ,
  useEmitBillingAddress ,
  getPaymentMethodAndType ,
  useEmitPaymentMethodStatus ,
  useEmitSurchargeInfo ,
}
/* jotai Not a pure module */
